module.exports = __webpack_public_path__ + "static/media/text.2683f97f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mediaDnd/text.svg
// module id = 1414
// module chunks = 1